<template>
  <div class="NotFound">
    <div class="logo-404"></div>
    <div class="textAreaa">
      お探しのページは見つかりませんでした<br>
      一時的にアクセスできないか、移動・削除した可能性があります
    </div>
    <sub-btn @click="onHome()">プリクラONのホームに戻る</sub-btn>
  </div>
</template>

<script>
import SubBtn from '../components/SubBtn.vue'
export default {
  components: { SubBtn },
  mixins: [],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    onHome() {
      this.$router.push('/')
    },
  },
  mounted () {
  }
}
</script>
<style lang="scss">
.NotFound {
  padding-top: 30px;
}
.logo-404 {
  width: 225px;
  height: 120px;
  margin: 30px auto 0;
  background-image: url(../assets/Png/Common/image_404.jpg);
  background-size: contain;
}
.textAreaa {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
